import React, { useState, useEffect } from "react";
import { useSelector } from "store";

// third-party
import { IntlProvider, MessageFormatElement } from "react-intl";

//utils
import { loadLocaleData } from "shared/utils/localesHelper";

//type
import { LocaleMessageFormatElement } from "shared/types/config";


interface LocalsProps {
  children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
  const { i18n } = useSelector((state) => state.config);
  const [messages, setMessages] = useState<
    Record<string, string> | Record<string, MessageFormatElement[]> | undefined
  >();
  useEffect(() => {
    loadLocaleData(i18n).then(
      (d: { default: LocaleMessageFormatElement | undefined }) => {
        setMessages(d.default);
      },
    );
  }, [i18n]);

  return (
    <>
      {messages && (
        <IntlProvider locale={i18n} defaultLocale='ru' messages={messages}>
          {children}
        </IntlProvider>
      )}
    </>
  );
};

export default Locales;
